import { render, staticRenderFns } from "./DropdownItemStatus.vue?vue&type=template&id=e89d7c6c&"
import script from "./DropdownItemStatus.vue?vue&type=script&lang=js&"
export * from "./DropdownItemStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e89d7c6c')) {
      api.createRecord('e89d7c6c', component.options)
    } else {
      api.reload('e89d7c6c', component.options)
    }
    module.hot.accept("./DropdownItemStatus.vue?vue&type=template&id=e89d7c6c&", function () {
      api.rerender('e89d7c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/components/DropdownItemStatus.vue"
export default component.exports